import { Breadcrumbs } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import useBreadcrumbItems from '@xver/hooks/useBreadcrumbItems';
import usePageHeading from '@xver/hooks/usePageHeading';
import { ApplicationState } from '@xver/store';

import CreditCardMethod from './components/CreditCardMethod';
import MethodCards from './components/MethodCards';
import PromptPayMethod from './components/PromptPayMethod';
import TopupHero from './components/TopupHero';
import TrueWalletMethod from './components/TrueWalletMethod';
import { TopupMethod } from './methodTheme';

export default function TopupPage() {
    const { t } = useTranslation('topup');
    const headingRef = usePageHeading(t('page.title'));
    const user = useSelector((state: ApplicationState) => state.auth.user);
    const [method, setMethod] = useState<TopupMethod>('promptpay');

    const breadcrumbItems = useBreadcrumbItems([
        { title: t('breadcrumb.platform'), href: '#' },
        { title: t('breadcrumb.topup') },
    ]);

    return (
        <div className="w-full min-h-full flex flex-col justify-start items-center gap-8">
            <div className="w-full flex flex-col justify-start items-start">
                <Breadcrumbs separatorMargin="xs" className="mb-6">
                    {breadcrumbItems}
                </Breadcrumbs>
                <div className="w-full flex flex-row justify-between items-end">
                    <div className="flex flex-col gap-1">
                        <h1 ref={headingRef} tabIndex={-1} className="text-3xl font-bold">
                            {t('page.title')}
                        </h1>
                        <p className="w-auto max-w-150 text-base text-fg/68">
                            {t('page.description')}
                        </p>
                    </div>
                </div>
            </div>

            <div className="w-full flex flex-col gap-6">
                <TopupHero />
                <div className="w-full rounded-md overflow-hidden border-[0.5px] border-line bg-surface-1 flex flex-col md:flex-row">
                    <div className="w-full md:w-72 md:shrink-0 border-b-[0.5px] md:border-b-0 md:border-r-[0.5px] border-line">
                        <MethodCards method={method} onChange={setMethod} />
                    </div>
                    <div className="flex-1 min-w-0">
                        {method === 'promptpay' && <PromptPayMethod />}
                        {method === 'truewallet' && (
                            <TrueWalletMethod defaultPhone={user?.phoneNumber} />
                        )}
                        {/* {method === 'internetBank' && <InternetBankMethod />} */}
                        {method === 'creditCard' && <CreditCardMethod />}
                    </div>
                </div>
            </div>
        </div>
    );
}
